import { get } from "lodash";
import { WroWagerGroup } from "@tvg/ts-types/WroWager";
import { WatchQueryFetchPolicy } from "@apollo/client";
import { isEqual } from "date-fns";
import { GetAllWagerTypesQueryProps } from "../types";

const getRaces = (
  bets: WroWagerGroup[] = [],
  raceDate: string
): Array<{ trackCode: string }> =>
  bets
    .filter((bet) => {
      const [date] = bet.value.split("|");

      return isEqual(new Date(date), new Date(raceDate));
    })
    .map((bet) => {
      const [, trackCode] = bet.value.split("|");

      return { trackCode };
    });

export default {
  apolloOptions: (props: GetAllWagerTypesQueryProps) => {
    const variables = {
      wagerProfile: get(props, "wagerProfile", ""),
      races: getRaces(
        get(props, "queryBets.bets", []),
        get(props, "raceDate", "")
      )
    };

    return {
      skip: get(props, "queryBets.bets.length", 0) === 0,
      fetchPolicy: "cache-and-network" as WatchQueryFetchPolicy,
      nextFetchPolicy: "cache-first" as WatchQueryFetchPolicy,
      ssr: false,
      variables
    };
  }
};
